export const animationVariants = {
    textVariant: {
        hidden: {
            y: 50,
            opacity: 0,
        },
        visible: {
            y: 0,
            opacity: 1,
        },
    },
    titleVariant: {
        hidden: {
            y: 30,
            opacity: 0,
        },
        visible: {
            y: 0,
            opacity: 1,
        },
    },

    titleVariantMobile: {
        hidden: {
            y: 10,
            opacity: 0,
        },
        visible: {
            y: 0,
            opacity: 1,
        },
    },

    rightToLeftVariant: {
        hidden: {
            x: 100,
            opacity: 0,
        },
        visible: {
            x: 0,
            opacity: 1,
        },
    },

    leftToRightVariant: {
        hidden: {
            x: -100,
            opacity: 0,
        },
        visible: {
            x: 0,
            opacity: 1,
        },
    },

    imgVariant: {
        hidden: {
            width: '0',
            opacity: 0,
        },
        visible: {
            width: '100%',
            opacity: 1,
        },
    },

    cardsVariant: {
        hidden: {
            scale: 0.8,
            opacity: 0,
        },
        visible: {
            scale: 1,
            opacity: 1,
        },
    },

    footerBackground: {
        hidden: {
            // scale: .8,
            // opacity: 0,
            x: -300,
        },
        visible: {
            // scale: 1,
            // opacity: 1,
            x: 0,
        },
    },
    staggerContainerVariant: {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3,
            },
        },
    },
};

export const animationParams = {
    initial: 'hidden',
    whileInView: 'visible',
    viewport: {
        amount: 0.2,
        once: true,
    },
    transition: {
        duration: 0.8,
        ease: 'easeInOut',
    },
};
